import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import Checkbox from "rc-checkbox";
import Uri from "jsuri";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
  getMetricForColumn,
} from "./../../Utils/Utils.js";
import Heading from "./../../Elements/Heading";

class Top100Videos extends Component {
  state = {
    networks: ["all"],
  };

  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title, url, pagination } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: new Uri(url).hasQueryParam("p")
            ? new Uri(url).getQueryParamValue("p")
            : url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        sort: true,
      },
      {
        dataField: "current_rank",
        text: "Current Rank",
        headerFormatter: (col, colIndex, { sortElement }) => (
          <div>Current Rank {sortElement}</div>
        ),
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        formatExtraData: { format: "0" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "previous_rank",
        text: "Previous Rank",
        headerFormatter: (col, colIndex, { sortElement }) => (
          <div>Previous Rank {sortElement}</div>
        ),
        style: { width: "130px", minWidth: "130px" },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "shares",
        text: "Shares",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "likes",
        text: "Likes",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "current_rank",
        order: "asc",
      },
    ];

    let paginate = null;

    if (pagination === true) {
      paginate = paginationFactory({
        sizePerPage: 10,
        hideSizePerPage: true,
      });
    }

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            pagination={paginate}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  onChangeAll = (e) => {
    this.setState({
      networks: ["all"],
    });
  };

  onChange = (e) => {
    let NAME = e.target.name;
    e.target.checked ? this.addItem(NAME) : this.removeItem(NAME);
  };

  addItem = (item) => {
    this.setState({
      networks: [...this.state.networks.filter((i) => i !== "all"), item],
    });
  };

  removeItem = (item) => {
    const NETWORKS = this.state.networks.filter((i) => i !== item);
    this.setState({
      networks: NETWORKS.length === 0 ? ["all"] : NETWORKS,
    });
  };

  renderFilters = (data) => {
    const NETWORKS_ARRAY = [...new Set(data.map((o) => o.network))];

    const checkboxes = NETWORKS_ARRAY.map((item) => (
      <label key={item} className="filters__checkbox_label">
        <Checkbox
          name={item}
          checked={this.state.networks.includes(item)}
          onChange={this.onChange}
        />
        <span className="filters__checkbox_label-text">{item}</span>
      </label>
    ));

    return (
      <div className="row">
        <div className="col-12">
          <section className="filters">
            <label className="filters__checkbox_label">
              <Checkbox
                name="all"
                checked={this.state.networks.includes("all")}
                onChange={this.onChangeAll}
              />
              <span className="filters__checkbox_label-text">Everything</span>
            </label>
            {checkboxes}
          </section>
        </div>
      </div>
    );
  };

  sortByViews50 = (data) =>
    data.sort((a, b) => b.views.value - a.views.value).slice(0, 50);

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={560} />;
    }

    let table_data = data.data;

    if (this.state.networks.includes("all")) {
      table_data = this.sortByViews50(table_data);
    } else {
      let filters = this.state.networks;
      table_data = data.data.filter((o) => filters.includes(o.network));
      table_data = this.sortByViews50(table_data);
    }

    return (
      <>
        <Heading size={6} key={"heading"}>
          The following sources provide data in Realtime: Facebook, Twitter, and
          Instagram. Youtube provides data from 2 days ago.
        </Heading>

        {this.renderFilters(data.data)}
        {this.renderTable(table_data)}
      </>
    );
  }
}

export default Top100Videos;
